import { createContext, useContext } from 'react';

interface V1aTrialContextValue {
  /** Opens the sign-up dialog. Every "Testar grátis" CTA on the page (cards, closing band) calls it. */
  openTrial: () => void;
}

export const V1aTrialContext = createContext<V1aTrialContextValue>({ openTrial: () => {} });

export function useV1aTrial(): V1aTrialContextValue {
  return useContext(V1aTrialContext);
}
